import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

export type AudienceOption = ListOptionWithCount & {
    htmlUrlPath?: string;
};

type Audience = {
    id: string;
    name: string;
    membershipStats: {totalCount: {value: number}};
    isWebFX: boolean;
    isSyncing: boolean;
    htmlUrlPath: string;
};

export function mapAudienceToSelectItem(audience: Audience): AudienceOption {
    return {
        value: audience.id,
        label: audience.name,
        count: audience.membershipStats.totalCount.value,
        isFx: audience.isWebFX,
        isSyncing: audience.isSyncing,
        htmlUrlPath: audience.htmlUrlPath,
    };
}
